@if (isUserConnected()) {
  <div class="container">
    <form class="form-gap" novalidate (submit)="$event.preventDefault();">
      <div class="pos">
        <ml-select-signal
          [class]="'flex-1 align-start'"
          [id]="'webstoreIdChoice'"
          [label]="'application.leads.pos-choice' | translate"
          [mapValues]="tveiListMap"
          [formField]="filterForm.pos"
        />
        <ml-text-icon-signal-input
          [iconName]="'magnifying-glass'"
          [class]="'flex-1 min-width-30'"
          [id]="'cckNumberChoice'"
          [placeholder]="'application.leads.cck-number-placeholder' | translate"
          [label]="'application.leads.cck-number' | translate"
          [maxlength]="10"
          (enterEvent)="searchWithCckNumber()"
          [formField]="filterForm.cckNumber"
        />
      </div>
      <ml-text-icon-signal-input
        [iconName]="'magnifying-glass'"
        [class]="'flex-1 min-width-30'"
        [id]="'clientNameChoice'"
        [label]="'application.leads.client-name' | translate"
        [maxlength]="50"
        [placeholder]="'application.leads.client-name-placeholder' | translate"
        (enterEvent)="searchWithClientName()"
        [formField]="filterForm.name"
      />
    </form>

    <div #table class="leads" tabindex="-1">
      @if (leads() || loadedLeads?.length) {
        @if (loadedLeads?.length) {
          <ml-table-v2
            [pagination]="pageEvent"
            [columns]="getColumns()"
            [data]="loadedLeads!"
            [expandable]="true"
            (changedPage)="onPageChanged($event)"
            (cellClickedEmitter)="onCellClick($event)"
            [isLoadingState]="!leads()?.length"
          />
        } @else {
          <div class="no-result-screen">
            <div class="no-result">
              {{ 'application.leads.no-result' | translate | uppercase }}
            </div>
            @if (hasAtLeastOneFilter()) {
              <ml-loading-button
                [label]="'application.records.reset-filters-button' | translate"
                [size]="'medium'"
                (event)="resetFilters()"
                (keydown)="onKeyDownResetFilters($event)"
              ></ml-loading-button>
            }
          </div>
        }
      } @else {
        <ml-loader />
      }
    </div>
  </div>
}
